import React from "react";

export default function FullscreenIcon(props: React.SVGProps<SVGSVGElement>) {

    return <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M140-140v-300h60v198.23L718.23-760H520v-60h300v300h-60v-198.23L241.77-200H440v60H140Z"/></svg>
;
}